/* ==========================================================================
   pb-motion.js — Reveal on scroll + (placeholder) sticky CTA.
   JS mínimo, sin dependencias. Respeta prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----- Reveal on scroll ----- */
  function initReveal() {
    var els = document.querySelectorAll('.pb-reveal:not(.is-revealed)');
    if (!els.length) return;

    // Sin IntersectionObserver o con reduce-motion: mostrar todo de una.
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  /* ----- Sticky CTA móvil (página de producto; activa cuando exista) ----- */
  function initStickyCta() {
    var bar = document.querySelector('[data-pb-sticky-cta]');
    if (!bar) return;
    var anchor = document.querySelector('[data-pb-buybox]');
    if (!anchor || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        // Mostrar la barra cuando la buy box principal sale de pantalla.
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  }

  function init() {
    initReveal();
    initStickyCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-evaluar al editar en el theme editor de Shopify.
  document.addEventListener('shopify:section:load', initReveal);
})();
